import { post } from '../utils/fetch';

// 心跳埋点
export const setHeartBeat = p => post('/wecom-manage/api/v1.0/trajectory/heartbeat', p, { visitor: true });
